<div class="targets-container">
  @for (group of taskTargetGroups(); track group.taskId) {
    <div class="task-group" [attr.data-task]="group.taskId">
      <div class="task-title-row">
        <cb-task-icon-button
          [icon]="getTaskIcon(group.taskId)"
          [taskId]="group.taskId"
          [projectId]="cbProject()?._id || ''"
          (iconChange)="onTaskIconChange(group.taskId, $event)"
        />
        <h3 class="task-title">{{ group.taskName }}</h3>
      </div>

      <div class="targets-list">
        @for (metric of group.metrics; track metric._id; let i = $index) {
          @if (metric.target; as target) {
            <div class="target-row">
              <!-- Metric Name -->
              <p class="metric-name">{{ metric.name }}</p>

              <!-- Value Input -->
              <div class="metric-input">
                @if (isDualDurationInput(metric)) {
                  <!-- Two inputs for hrs/min or min/sec -->
                  <div class="dual-input-container">
                    <input
                      type="number"
                      class="value-input dual-input"
                      placeholder="00"
                      [value]="getDurationPrimaryValue(target, normalizeDurationType(metric.typeOption))"
                      (input)="onDurationPrimaryChange($event, group.taskId, i, metric)"
                      (blur)="onDurationBlur($event, group.taskId, i, metric, 'primary')"
                    />
                    <span class="dual-input-separator">:</span>
                    <input
                      type="number"
                      class="value-input dual-input"
                      placeholder="00"
                      min="0"
                      max="59"
                      [value]="getDurationSecondaryValue(target, normalizeDurationType(metric.typeOption))"
                      (input)="onDurationSecondaryChange($event, group.taskId, i, metric)"
                      (blur)="onDurationBlur($event, group.taskId, i, metric, 'secondary')"
                    />
                  </div>
                } @else {
                  <!-- Single input for other types -->
                  <input
                    type="number"
                    class="value-input"
                    [placeholder]="metric.type === TrackerMetricTypes.Duration ? '00' : '0'"
                    [attr.min]="metric.type === TrackerMetricTypes.Percentage ? 0 : null"
                    [attr.max]="metric.type === TrackerMetricTypes.Percentage ? 100 : null"
                    [value]="
                      metric.type === TrackerMetricTypes.Duration && metric.typeOption
                        ? (target.targetValue | durationDisplay: normalizeDurationType(metric.typeOption) : 'primary')
                        : target.targetValue
                    "
                    (input)="onInputChange($event, group.taskId, i, metric)"
                    (blur)="
                      metric.type === TrackerMetricTypes.Percentage ? onPercentageBlur($event, group.taskId, i) : null
                    "
                  />
                }
              </div>

              <!-- Suffix Text -->
              <div class="metric-suffix">{{ getSuffixDisplay(metric) }}</div>

              <!-- Operator Menu -->
              <button type="button" class="select-button operator-button" [matMenuTriggerFor]="operatorMenu">
                {{ getOperatorDisplayValue(target) }}
                <mat-icon svgIcon="chevron-down"></mat-icon>
              </button>
              <mat-menu #operatorMenu="matMenu" class="oph-select-menu">
                @for (operator of operatorOptions; track operator.value) {
                  <button
                    type="button"
                    (click)="onOperatorChange(group.taskId, i, operator)"
                    class="oph-select-menu-item"
                  >
                    <div class="operator-container">
                      <span class="operator-text">{{ operator.display }}</span>
                    </div>
                  </button>
                }
              </mat-menu>

              <!-- Period Menu -->
              <button type="button" class="select-button period-button" [matMenuTriggerFor]="periodMenu">
                {{ getPeriodDisplayValue(target) }}
                <mat-icon svgIcon="chevron-down"></mat-icon>
              </button>
              <mat-menu #periodMenu="matMenu" class="oph-select-menu">
                @for (period of periodOptions; track period.value) {
                  <button type="button" (click)="onPeriodChange(group.taskId, i, period)" class="oph-select-menu-item">
                    {{ period.display }}
                  </button>
                }
              </mat-menu>

              <!-- Days of Cycle Menu (only shown when period is 'day') -->
              @if (target.targetPeriod === 'perDay') {
                <button type="button" class="select-button days-of-cycle-button" [matMenuTriggerFor]="daysOfCycleMenu">
                  {{ getDaysOfCycleDisplayValue(target) }}
                  <mat-icon svgIcon="chevron-down"></mat-icon>
                </button>
                <mat-menu #daysOfCycleMenu="matMenu" class="oph-select-menu">
                  @for (days of getDaysOfCycleOptions(); track days) {
                    <button
                      type="button"
                      (click)="onDaysOfCycleChange(group.taskId, i, days)"
                      class="oph-select-menu-item"
                    >
                      {{ days }} of {{ cbProject()?.challengeBuilder.cycleLength || 7 }} days
                    </button>
                  }
                </mat-menu>
              }
            </div>
          }
        }
      </div>
    </div>
  }
</div>
